import SectionMessage from '@atlaskit/section-message';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const SubscriptionHasBeenMovedMessage = ({ transactionAccountId, externalUuid }) => (
  <SectionMessage>
    <span>
      <FormattedMessage
        id="mac.licenses.subscription.message"
        defaultMessage="This subscription has been moved to the new billing system. View and manage it in the "
      />
      <a
        href={`https://ppc.atlassian.com/account/${transactionAccountId}/cloud-sites/${externalUuid}`}
      >
        <FormattedMessage
          id="mac.licenses.subscription.message.link"
          defaultMessage="Partner Purchasing Center"
        />
      </a>
    </span>
  </SectionMessage>
);
